// tienda/TierCard.jsx
// Pricing tier card used in ModalidadesSection.
// Props: icon, tag, tagColor, title, price, cutoff, delivery, perks[], featured

import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Clock, CheckCircle2 } from "lucide-react";
import { brand, fadeUp } from "../shared/brand";

export function TierCard({ icon, tag, tagColor, title, price, cutoff, delivery, perks, featured }) {
  return (
    <motion.div
      {...fadeUp}
      className="rounded-2xl border bg-white p-5"
      style={
        featured
          ? { borderColor: tagColor, boxShadow: `0 4px 24px ${tagColor}25` }
          : { borderColor: "#e2e8f0" }
      }
    >
      {/* Icon + tag row */}
      <div className="flex items-start justify-between mb-4">
        <div
          className="size-10 rounded-xl flex items-center justify-center"
          style={{ background: tagColor + "20", color: tagColor }}
        >
          {icon}
        </div>
        <span
          className="rounded-full px-2.5 py-0.5 text-[11px] font-bold text-white"
          style={{ background: tagColor }}
        >
          {tag}
        </span>
      </div>

      <h3 className="text-base font-extrabold text-slate-800 mb-1">{title}</h3>

      {/* Price */}
      <div className="flex items-baseline gap-1.5 mb-1">
        <span className="text-2xl font-extrabold" style={{ color: brand.primary }}>{price}</span>
        <span className="text-xs text-slate-400">c/u</span>
      </div>

      {/* Cutoff */}
      <div className="flex items-center gap-1.5 mb-4">
        <Clock className="size-3.5" style={{ color: tagColor }} />
        <span className="text-xs font-semibold" style={{ color: tagColor }}>{cutoff}</span>
        <span className="text-slate-300">·</span>
        <span className="text-xs text-slate-500">{delivery}</span>
      </div>

      {/* Perks list */}
      <ul className="space-y-2 mb-5">
        {perks.map(perk => (
          <li key={perk} className="flex items-start gap-2 text-xs text-slate-600">
            <CheckCircle2 className="size-3.5 mt-0.5 shrink-0" style={{ color: tagColor }} />
            {perk}
          </li>
        ))}
      </ul>

      <Link
        to="/register"
        className="block w-full rounded-xl py-2.5 text-center text-sm font-bold text-white"
        style={{ background: tagColor }}
      >
        Empezar ahora
      </Link>
    </motion.div>
  );
}